(function () {
  'use strict';

  /* @ngdoc object
   * @name flightScreen
   * @description
   *
   */
  angular
    .module('flightScreen', [
      'ui.router'
    ]);
}());
